import {IAction, ActionType} from '../Actions';
import {ILocalAnswersForComp} from '@chancer/common/lib/interfaces/client/ClientInterfaces';

export const localAnswersMessage = (
  answers: ILocalAnswersForComp,
): IAction<ILocalAnswersForComp> => ({
  payload: answers,
  type: ActionType.LOCAL_ANSWERS_MESSAGE,
});
